.text {
  a {
    text-decoration: underline;
  }
}
